






















import { Component, Vue, Prop } from "vue-property-decorator";
import { Getter } from "vuex-class";
import ConfirmDialog from "@/components/common/ConfirmDialog.vue";
import requestService from "@/service/requestService";
import { IppanSeibiService } from "@/service/IppanSeibiService";
import NextageFooter from "@/components/nextageFooter.vue";
@Component({
  components: { 
    ConfirmDialog 
    , NextageFooter
  }
})
export default class UserFooter extends Vue {
  @Prop({ default: false })
  checkIsEdit: boolean;
  @Prop({ default: false }) disabled: boolean;

  @Getter("uketsukeExtendsId", { namespace: "ReservationDetail" })
  uketsukeExtendsId: number;
  @Getter("uketsukeCd", { namespace: "ReservationDetail" })
  uketsukeCd: string;
  @Getter("yoyakuNo", { namespace: "ReservationDetail" })
  yoyakuNo: string;
  /** 2024-05-02 nextage [START] */
  @Getter("isNextageCustom", { namespace: "FunctionSetting" })
  isNextageCustom: any;
  /** 2024-05-02 nextage [END] */

  ippanSeibiService: IppanSeibiService = new IppanSeibiService();

  $refs!: {
    dialog: ConfirmDialog;
    cancelDialog: ConfirmDialog;
  };

  gotoCustomer() {
    this.$router.push({
      name: "usercustomer",
      params: { code: this.yoyakuNo }
    });
  }

  onConfirm() {
    if (this.checkIsEdit) {
      this.$emit("onconfirm");
    } else {
      this.onSave();
    }
  }

  onSave() {
    this.$emit("onsave");
    this.$refs.dialog.onOpen();
  }

  onSubmit() {
    this.$router.push({
      name: "reservationNumber"
    });
  }

  onCancel() {
    if (this.$refs.cancelDialog) {
      this.$refs.cancelDialog.onOpen();
    }
  }

  cancel() {
    const reqService: requestService = new requestService();
    const data = {
      sknUketsukeExtendsId: this.uketsukeExtendsId,
      uketsukeCd: this.uketsukeCd,
      yoyakuNo: this.yoyakuNo
    };
    reqService.saveCancel(data).then((res: any) => { // sendSocket:32車検中止
      this.$router.push({ name: "reservationNumber" });
    });
  }
}
